import React from 'react';
import classnames from 'classnames';
import styles from './radio.module.scss';

export type RadioProps = {
  value: React.InputHTMLAttributes<HTMLInputElement>['value'];
  label: string | JSX.Element;
  id: string;
  isInvalid?: boolean;
} & Pick<
  React.InputHTMLAttributes<HTMLInputElement>,
  'checked' | 'onChange' | 'autoFocus' | 'className' | 'disabled' | 'name' | 'required'
>;

const baseClass = 'radio';

export const Radio = React.forwardRef<HTMLInputElement, RadioProps>(
  ({ id, label, name, value, onChange, className, disabled, required, checked, isInvalid, autoFocus }, ref) => {
    const classes = classnames(
      styles.radio,
      {
        [styles[`${baseClass}--error`]]: isInvalid
      },
      className
    );
    const labelClassNames = styles[`${baseClass}__label`];
    const labelId = `${id}_label`;
    const messageId = `${id}__message`;

    return (
      <div className={classes} data-testid="radio-component">
        <div className={styles[`${baseClass}__alignment-wrapper`]}>
          <div className={styles[`${baseClass}__input-wrapper`]}>
            <input
              ref={ref}
              disabled={disabled}
              required={required}
              onChange={onChange}
              className={styles[`${baseClass}__input`]}
              checked={checked}
              type="radio"
              id={id}
              name={name}
              value={value}
              aria-labelledby={labelId}
              aria-describedby={messageId}
              autoFocus={autoFocus}
            />
          </div>
          <div className={styles[`${baseClass}__input-circle-shadow-area`]} />
          <label className={labelClassNames} htmlFor={id} id={labelId}>
            {label}
          </label>
        </div>
      </div>
    );
  }
);

Radio.displayName = 'Radio';
